module.exports = __webpack_public_path__ + "img/srb.291d0fb6.svg";